import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

export default function request(engineKey, method, path, params) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var headers, response, json, message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = new Headers({
              "Content-Type": "application/json"
            });
            _context.next = 3;
            return fetch("https://search-api.swiftype.com/api/v1/public/".concat(path), {
              method: method,
              headers: headers,
              body: JSON.stringify(Object.assign({
                engine_key: engineKey
              }, params)),
              credentials: "include"
            });

          case 3:
            response = _context.sent;
            _context.prev = 4;
            _context.next = 7;
            return response.json();

          case 7:
            json = _context.sent;
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);

          case 12:
            if (!(response.status >= 200 && response.status < 300)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", json);

          case 16:
            message = json && json.errors && Object.entries(json.errors).length > 0 ? JSON.stringify(json.errors) : response.status;
            throw new Error("".concat(message));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
}